import { render, staticRenderFns } from "./ColorsDoItBeautifulSection.vue?vue&type=template&id=65c5e93e"
import script from "./ColorsDoItBeautifulSection.vue?vue&type=script&lang=ts"
export * from "./ColorsDoItBeautifulSection.vue?vue&type=script&lang=ts"
import style0 from "./ColorsDoItBeautifulSection.vue?vue&type=style&index=0&id=65c5e93e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports